(() => {
  // 只針對素材輪播，不碰產品 media-gallery
  const IMG_SELECTOR = ".slideshow-section img.slide__image";

  let state = {
    items: [],
    index: 0,
    // zoom/pan
    scale: 1,
    tx: 0,
    ty: 0,
    isPanning: false,
    panStartX: 0,
    panStartY: 0,
    panBaseX: 0,
    panBaseY: 0,
    pointers: new Map(),
    pinchStartDist: 0,
    pinchStartScale: 1
  };

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function ensureLightbox() {
    if (document.getElementById("slideshowLightbox")) return;

    const wrap = document.createElement("div");
    wrap.id = "slideshowLightbox";
    wrap.innerHTML = `
      <div class="slb__backdrop" aria-hidden="true"></div>

      <div class="slb__stage" role="dialog" aria-modal="true" aria-label="Image viewer">
        <button class="slb__close" type="button" aria-label="Close">×</button>

        <button class="slb__nav slb__prev" type="button" aria-label="Previous">‹</button>
        <button class="slb__nav slb__next" type="button" aria-label="Next">›</button>

        <div class="slb__frame">
          <img class="slb__img" alt="" draggable="false" />
        </div>

        <div class="slb__meta">
          <span class="slb__count">1 / 1</span>
          <span class="slb__hint">滑動切換・捏合縮放</span>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);

    const close = () => wrap.classList.remove("is-open");

    // close interactions
    qs(".slb__backdrop", wrap).addEventListener("click", close);
    qs(".slb__close", wrap).addEventListener("click", close);

    // nav
    qs(".slb__prev", wrap).addEventListener("click", () => move(-1));
    qs(".slb__next", wrap).addEventListener("click", () => move(1));

    // keyboard
    document.addEventListener("keydown", (e) => {
      if (!wrap.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") move(-1);
      if (e.key === "ArrowRight") move(1);
    });

    // wheel zoom (desktop)
    qs(".slb__frame", wrap).addEventListener("wheel", (e) => {
      if (!wrap.classList.contains("is-open")) return;
      e.preventDefault();
      const delta = -e.deltaY;
      const step = delta > 0 ? 0.12 : -0.12;
      setZoom(state.scale + step);
    }, { passive: false });

    // touch swipe + pinch + pan (pointer events)
    const frame = qs(".slb__frame", wrap);
    frame.addEventListener("pointerdown", onPointerDown);
    frame.addEventListener("pointermove", onPointerMove);
    frame.addEventListener("pointerup", onPointerUpCancel);
    frame.addEventListener("pointercancel", onPointerUpCancel);

    // double click / double tap to zoom toggle
    let lastTap = 0;
    frame.addEventListener("click", () => {
      const now = Date.now();
      if (now - lastTap < 280) {
        // toggle zoom
        if (state.scale > 1) resetTransform();
        else setZoom(2);
      }
      lastTap = now;
    });
  }

  function openLightbox(items, index) {
    ensureLightbox();
    const wrap = document.getElementById("slideshowLightbox");
    state.items = items;
    state.index = index;

    wrap.classList.add("is-open");
    render();
  }

  function render() {
    const wrap = document.getElementById("slideshowLightbox");
    const img = qs(".slb__img", wrap);
    const count = qs(".slb__count", wrap);

    const item = state.items[state.index];
    img.src = item.src;
    img.alt = item.alt || "";

    count.textContent = `${state.index + 1} / ${state.items.length}`;

    // reset zoom/pan on slide change
    resetTransform();
  }

  function move(dir) {
    const wrap = document.getElementById("slideshowLightbox");
    if (!wrap || !wrap.classList.contains("is-open")) return;

    const len = state.items.length;
    if (len <= 1) return;

    state.index = (state.index + dir + len) % len;
    render();
  }

  function resetTransform() {
    state.scale = 1;
    state.tx = 0;
    state.ty = 0;
    applyTransform();
  }

  function setZoom(nextScale) {
    state.scale = clamp(nextScale, 1, 4);
    if (state.scale === 1) {
      state.tx = 0;
      state.ty = 0;
    }
    applyTransform();
  }

  function applyTransform() {
    const wrap = document.getElementById("slideshowLightbox");
    if (!wrap) return;
    const img = qs(".slb__img", wrap);

    img.style.transform = `translate(${state.tx}px, ${state.ty}px) scale(${state.scale})`;
    img.style.cursor = state.scale > 1 ? "grab" : "zoom-out";
  }

  // Pointer helpers
  function distance(a, b) {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    return Math.hypot(dx, dy);
  }

  function onPointerDown(e) {
    const wrap = document.getElementById("slideshowLightbox");
    if (!wrap || !wrap.classList.contains("is-open")) return;

    e.currentTarget.setPointerCapture(e.pointerId);
    state.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

    // start pan
    if (state.scale > 1 && state.pointers.size === 1) {
      state.isPanning = true;
      state.panStartX = e.clientX;
      state.panStartY = e.clientY;
      state.panBaseX = state.tx;
      state.panBaseY = state.ty;
      applyTransform();
    }

    // start pinch
    if (state.pointers.size === 2) {
      const pts = Array.from(state.pointers.values());
      state.pinchStartDist = distance(pts[0], pts[1]);
      state.pinchStartScale = state.scale;
      state.isPanning = false;
    }

    // swipe start (for slide change when not zoomed)
    if (state.scale === 1 && state.pointers.size === 1) {
      state.swipeStartX = e.clientX;
      state.swipeStartY = e.clientY;
      state.swiping = true;
    }
  }

  function onPointerMove(e) {
    const wrap = document.getElementById("slideshowLightbox");
    if (!wrap || !wrap.classList.contains("is-open")) return;

    if (!state.pointers.has(e.pointerId)) return;
    state.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

    // pinch zoom
    if (state.pointers.size === 2) {
      const pts = Array.from(state.pointers.values());
      const dist = distance(pts[0], pts[1]);
      if (state.pinchStartDist > 0) {
        const ratio = dist / state.pinchStartDist;
        setZoom(state.pinchStartScale * ratio);
      }
      return;
    }

    // pan when zoomed
    if (state.scale > 1 && state.isPanning && state.pointers.size === 1) {
      const dx = e.clientX - state.panStartX;
      const dy = e.clientY - state.panStartY;
      state.tx = state.panBaseX + dx;
      state.ty = state.panBaseY + dy;
      applyTransform();
      return;
    }

    // swipe to change slide (only when not zoomed)
    if (state.scale === 1 && state.swiping && state.pointers.size === 1) {
      state.swipeLastX = e.clientX;
      state.swipeLastY = e.clientY;
    }
  }

  function onPointerUpCancel(e) {
    const wrap = document.getElementById("slideshowLightbox");
    if (!wrap || !wrap.classList.contains("is-open")) return;

    state.pointers.delete(e.pointerId);

    // end pan
    if (state.pointers.size === 0) {
      state.isPanning = false;
    }

    // end swipe -> decide slide move
    if (state.scale === 1 && state.swiping) {
      state.swiping = false;
      const startX = state.swipeStartX ?? 0;
      const endX = state.swipeLastX ?? startX;
      const dx = endX - startX;

      // threshold
      if (Math.abs(dx) > 50) {
        move(dx > 0 ? -1 : 1);
      }
    }

    // if pinch ended, reset pinch baseline
    if (state.pointers.size < 2) {
      state.pinchStartDist = 0;
    }
  }

  // Click any slideshow image => open gallery of that slideshow-section
  document.addEventListener("click", (e) => {
    const img = e.target.closest(IMG_SELECTOR);
    if (!img) return;

    const section = img.closest(".slideshow-section");
    if (!section) return;

    const imgs = qsa("img.slide__image", section);

    const items = imgs.map((node) => ({
      src: node.currentSrc || node.src,
      alt: node.alt || ""
    }));

    const idx = Math.max(0, imgs.indexOf(img));
    openLightbox(items, idx);
  });
})();
